import {ref, Ref, watch} from '@vue/composition-api';
import {FeaturesController} from '../../../core/FeaturesController';

export enum CaptureType {
	IMAGE = 'image',
	VIDEO = 'video',
}
interface CaptureFormData {
	captureType: CaptureType;
	videoDuration: number;
	videoMbsPerSecond: number;
	// videoFPS: number;
}
type LocalStorageData = Partial<CaptureFormData>;
const LOCAL_STORAGE_KEY = 'EditorCaptureFormControllerClass';

type CaptureFormCallback = (args: CaptureFormData) => void;

export class EditorCaptureFormControllerClass {
	private static _instance: EditorCaptureFormControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorCaptureFormControllerClass());
	}

	private constructor() {}

	private _displayed!: Ref<boolean>;
	private _captureType!: Ref<CaptureType>;
	private _videoDuration!: Ref<number>;
	private _videoMbsPerSecond!: Ref<number>;
	// private _videoFPS!: Ref<number>; // not yet supported by the mediaRecorder
	private _resolve: CaptureFormCallback | undefined;
	init() {
		this._displayed = ref(false);
		const saved = this._loadLocalStorage();
		this._captureType = ref(saved?.captureType || CaptureType.IMAGE);
		this._videoDuration = ref(saved?.videoDuration == null ? 3 : saved?.videoDuration);
		this._videoMbsPerSecond = ref(
			saved?.videoMbsPerSecond == null
				? FeaturesController.viewerCaptureVideoMbsPerSecond() || 20
				: saved?.videoMbsPerSecond
		);
		// this._videoFPS = ref(saved?.videoFPS == null ? 30 : saved?.videoFPS);

		const saveToLocalStorage = this._saveToLocalStorage.bind(this);
		watch(this._captureType, saveToLocalStorage);
		watch(this._videoDuration, saveToLocalStorage);
		watch(this._videoMbsPerSecond, saveToLocalStorage);
		// watch(this._videoFPS, saveToLocalStorage);
	}

	// getters
	displayed() {
		return this._displayed.value;
	}
	captureType() {
		return this._captureType.value;
	}
	videoDuration() {
		return this._videoDuration.value;
	}
	videoMbsPerSecond() {
		return this._videoMbsPerSecond.value;
	}
	// videoFPS() {
	// 	return this._videoFPS.value;
	// }

	// mutations
	display(): Promise<CaptureFormData> {
		this._displayed.value = true;
		return new Promise((resolve) => {
			this._resolve = resolve;
		});
	}
	confirm() {
		if (this._resolve) {
			this._resolve(this._data());
		}
		this._close();
	}
	cancel() {
		this._close();
		this._resolve = undefined;
	}
	private _close() {
		this._displayed.value = false;
	}
	setCaptureType(type: CaptureType): void {
		this._captureType.value = type;
	}
	setVideoDuration(duration: number): void {
		this._videoDuration.value = duration;
	}
	setVideoMbsPerSecond(mbs: number) {
		this._videoMbsPerSecond.value = mbs;
	}
	private _data(): CaptureFormData {
		return {
			captureType: this._captureType.value,
			videoDuration: this._videoDuration.value,
			videoMbsPerSecond: this._videoMbsPerSecond.value,
			// videoFPS: this._videoFPS.value,
		};
	}

	private _saveToLocalStorage() {
		localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(this._data()));
	}
	private _loadLocalStorage() {
		const content = localStorage.getItem(LOCAL_STORAGE_KEY);
		if (!content) {
			return;
		}
		try {
			const json = JSON.parse(content) as LocalStorageData;
			return json;
		} catch (e) {
			return;
		}
	}
}

export const CaptureForm = EditorCaptureFormControllerClass.instance();
